import {
  isLocalhostAuthHost,
  signInAsAnonymous,
  signInWithGoogle,
} from '../../services/firebase/auth';

export function AuthGate(): JSX.Element {
  const showGuestLogin = isLocalhostAuthHost();

  return (
    <div className="flex h-full w-full items-center justify-center p-8">
      <div className="w-full max-w-md rounded-xl border border-slate-600 bg-slate-900/70 p-6 shadow-2xl">
        <h1 className="mb-2 text-3xl font-bold">Waysprite</h1>
        <p className="mb-6 text-sm text-slate-300">Sign in to enter the world.</p>
        <div className="flex flex-col gap-3">
          <button
            className="rounded-md bg-emerald-500 px-4 py-2 text-sm font-semibold text-slate-950 transition hover:bg-emerald-400"
            onClick={() => {
              void signInWithGoogle();
            }}
            type="button"
          >
            Continue with Google
          </button>
          {showGuestLogin ? (
            <button
              className="rounded-md border border-slate-400 px-4 py-2 text-sm font-semibold transition hover:bg-slate-700"
              onClick={() => {
                void signInAsAnonymous();
              }}
              type="button"
            >
              Continue as Guest
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
